import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IState } from './type'
import { IStatusData, IWhitelist } from 'services/type'

const initialState: IState = {
  data: [],
  status: IStatusData.PENDING,
  currentPage: 0,
  totalPage: 0,
  totalItem: 0,
  pageSize: 10,
  isLoading: false,
  isLoadingSC: false,
}

export const walletSlice = createSlice({
  name: 'whitelist',
  initialState,
  reducers: {
    setData: (state: IState, action: PayloadAction<Array<IWhitelist>>) => {
      state.data = action.payload
    },
    editItem: (state: IState, action: PayloadAction<IWhitelist>) => {
      const index = state.data.findIndex(
        (obj) => obj.walletAddress === action.payload.walletAddress
      )
      if (index > -1) state.data[index] = action.payload
    },
    setStatus: (
      state: IState,
      action: PayloadAction<IStatusData | undefined>
    ) => {
      state.status = action.payload
    },
    setCurrentPage: (state: IState, action: PayloadAction<number>) => {
      state.currentPage = action.payload
    },
    setTotalPage: (state: IState, action: PayloadAction<number>) => {
      state.totalPage = action.payload
    },
    setTotalItem: (state: IState, action: PayloadAction<number>) => {
      state.totalItem = action.payload
    },
    setPageSize: (state: IState, action: PayloadAction<number>) => {
      state.pageSize = action.payload
    },
    setLoading: (state: IState, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setLoadingSC: (state: IState, action: PayloadAction<boolean>) => {
      state.isLoadingSC = action.payload
    },
  },
})

export const {
  setLoading,
  setData,
  setStatus,
  editItem,
  setCurrentPage,
  setTotalPage,
  setPageSize,
  setLoadingSC,
  setTotalItem,
} = walletSlice.actions

export default walletSlice.reducer
